import React, { View, StyleSheet } from "react-native"
import FontAwesome5 from "react-native-vector-icons/FontAwesome5"
import TextM from "@common/components/text/TextM"
import { theme } from "@common/theme/theme"

export const RatingStars = ({ score, scale = 5 }) => {
    return (
        <View style={styles.starsContainer}>
            {Array.from({ length: scale }).map((_, index) => (
                <FontAwesome5
                    key={index}
                    name="star"
                    solid
                    size={16}
                    color={theme.colors.accent}
                    style={styles.star}
                />
            ))}
            <TextM
                fontSize={14}
                fontWeight="Bold"
                color={theme.colors.accentDark}
                style={styles.rating}
            >
                {score}/{scale}
            </TextM>
        </View>
    )
}

const styles = StyleSheet.create({
    starsContainer: {
        flexDirection: "row",
        alignItems: "center",
        gap: 2,
    },
    rating: {
        marginLeft: 8,
    },
})
